import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../links/Link';
import { useTranslation } from 'react-i18next';

function Affiliations({ domain, logos }) {
  const { t } = useTranslation();

  return (
    <div className="footer__content">
      <div className="content__base">
        <div className="base__content">
          {logos.map((logo, index) => (
            <Link key={index} href={logo.href} className="footer__logo" title={logo.title}>
              <img src={logo.source} alt={logo.alt} />
            </Link>
          ))}
          {domain === 'cw' && (
            <div className="cr">
              © {t('styleguide:careers_wales')} {new Date().getFullYear()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Affiliations.propTypes = {
  /**
   * The current domain
   */
  domain: PropTypes.string,
  /**
   * The logos
   */
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
      source: PropTypes.string,
      alt: PropTypes.string
    })
  )
};

export default Affiliations;
